'use client';
const IDENT = 'Loader';
const defaultProps = {
    role: 'presentation',
    size: 'md1',
    color: 'primary.base'
};

export { IDENT, defaultProps };
//# sourceMappingURL=Loader.contract.js.map
